import React from "react";
import { MessageCircle } from "lucide-react";
import { waLink } from "../lib/contact";

export const FloatingWhatsApp = () => {
  return (
    <a
      href={waLink()}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-cta"
      aria-label="Abrir conversación de WhatsApp con Royal Pets Veterinaria"
      className="pulse-whatsapp fixed bottom-5 right-5 sm:bottom-7 sm:right-7 z-50 inline-flex items-center gap-3 pl-4 pr-5 py-3.5 rounded-full bg-[#25D366] hover:bg-[#1EBE5A] text-white font-bold shadow-[0_14px_30px_rgba(37,211,102,0.45)] hover:-translate-y-0.5 transition-all duration-300"
    >
      <MessageCircle className="w-5 h-5" />
      <span className="hidden sm:inline">WhatsApp</span>
    </a>
  );
};

export default FloatingWhatsApp;
